<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <label class="label-name">所属公司：</label>
      <el-select
        size="small"
        :disabled="noSelectOrganization"
        class="organization-select"
        v-model="depId"
        placeholder="请选择所属公司"
      >
        <el-option
          v-for="item in organizationListData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="list-title" style="padding: 5px 10px 8px; background: #f8f8f8">
      <div class="filter-item" style="margin-bottom: 5px">
        <label>时间：</label>
        <el-date-picker
          style="width: 250px !important"
          v-model="startTime"
          size="mini"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="开始时间"
        ></el-date-picker
        ><span style="width: 30px; display: inline-block; text-align: center"
          >至</span
        >
        <el-date-picker
          style="width: 250px !important"
          v-model="endTime"
          size="mini"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="结束时间"
        ></el-date-picker>

        <label style="margin-left: 7px">项目组：</label>
        <el-select size="mini" v-model="teamId" placeholder="请选择">
          <el-option
            v-for="item in teamArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="filter-item" style="margin-bottom: 5px">
        <a
          :href="
            baseURL +
            '/pay/report/export?depId=' +
            (depId == 0 ? '' : depId) +
            '&startTime=' +
            startTime +
            '&endTime=' +
            endTime +
            '&isWx=' +
            isWx +
            '&wxType=' +
            wxType +
            '&teamId=' +
            (teamId == 0 ? '' : teamId) +
            '&filterKey=' +
            filterKey
          "
          style="float: right"
          target="_blank"
        >
          <el-button size="mini" type="primary">汇总表格下载</el-button>
        </a>

        <label>项目类型：</label>
        <el-select size="mini" v-model="projectType" placeholder="请选择">
          <el-option
            v-for="item in projectTypeArr"
            :key="item.type"
            :label="item.name"
            :value="item.type"
          >
          </el-option>
        </el-select>

        <label class="label-name ml5px">搜索：</label>
        <span style="width: 230px; display: inline-block">
          <el-input
            v-model="filterKey"
            size="mini"
            placeholder="你可以搜索项目编号/项目名"
          ></el-input>
        </span>

        <el-button
          type="success"
          @click="getFilterData()"
          style="margin-left: 5px"
          size="mini"
          >搜索筛选结果</el-button
        >
        <el-button
          type="primary"
          @click="resetFilterData()"
          style="margin-left: 5px"
          size="mini"
          >重置</el-button
        >
      </div>
    </div>

    <el-table :data="filterData" border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="number" label="项目编号" width="100px">
      </el-table-column>
      <el-table-column label="项目名称">
        <template slot-scope="scope">
          <router-link
            class="table-link"
            target="_blank"
            :to="'/Project/Detail/' + scope.row.projectId"
          >
            {{ scope.row.projectName }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="sghtj"
        label="工程合同(+补充)价"
        width="110px"
      ></el-table-column>
      <el-table-column
        prop="ljbfgck"
        label="累计支付款项"
        width="100px"
      ></el-table-column>
      <el-table-column
        prop="sygck"
        label="剩余款项"
        width="100px"
      ></el-table-column>
      <el-table-column label="付款详情" width="80px">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="showPayDetail(scope.row)"
            type="primary"
            >查看更多</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-left: -5px"
      v-if="form.pageTotal > form.pageSize"
      class="list-pagination"
      background
      :page-size="form.pageSize"
      :pager-count="9"
      :current-page="form.page + 1"
      layout="pager"
      :total="form.pageTotal"
      @current-change="handleCurrentChange"
    >
    </el-pagination>

    <!-- 项目支付详情弹窗 -->
    <div class="pop-room pop-pay-info" v-if="payInfoStatus">
      <div class="project-title">
        <h3 style="display: inline-block">项目：{{ nowProjectName }}</h3>
        <a
          style="display: inline-block; margin-left: 15px"
          target="_blank"
          :href="'/Project/Detail/' + nowProjectId"
        >
          <el-button type="primary" size="mini" plain>点击前往详情页</el-button>
        </a>
      </div>
      <a
        href="javascript:;"
        @click="payInfoStatus = false"
        class="iconfont icon-close"
      ></a>
      <div class="pop-cont">
        <!-- 支付相关 -->
        <info-pay :projectId="nowProjectId" :isParentProject="true"></info-pay>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import UserInfo from "@/components/UserInfo";
import Role from "@/Mixins/role";
import InfoPay from "./infoPay";
export default {
  components: {
    UserInfo,
    InfoPay,
  },
  mixins: [Role],
  computed: {
    ...mapState({
      organization: (state) => state.main.organization,
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      // 支付弹窗
      nowProjectId: 0,
      payInfoStatus: false,

      baseURL: axios.defaults.baseURL,

      organizationListData: [],
      noSelectOrganization: true,
      depId: "",
      startTime: "",
      endTime: "",

      // 列表
      loading: true,
      pageSize: 20,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: [],

      // 筛选搜索
      form: {
        page: 0,
        pageSize: 22,
      },
      filterKey: "",
      teamId: 0,
      teamArr: [],
      filterStatus: "全部",
      isWx: "",
      wxType: "",
      projectType: -1,
      projectTypeArr: [
        {
          type: -1,
          name: "所有",
        },
        {
          type: 0,
          name: "工程项目",
        },
        {
          type: 1,
          name: "微型项目A",
        },
        {
          type: 2,
          name: "微型项目B",
        },
      ],
    };
  },
  mounted() {
    // 默认选中6个月前时间
    var nowDate = new Date();
    var olddate = new Date(
      nowDate.getFullYear(),
      nowDate.getMonth() - 6,
      nowDate.getDate()
    );
    this.startTime =
      olddate.getFullYear() +
      "-" +
      (olddate.getMonth() + 1) +
      "-" +
      olddate.getDate();
    this.endTime =
      nowDate.getFullYear() +
      "-" +
      (nowDate.getMonth() + 1) +
      "-" +
      nowDate.getDate();

    this.organizationListData.push({
      id: 0,
      name: "集团所有公司",
      depId: 0,
    });
    let _or =
      this.organization.length > 0 ? this.organization[0].childDepts : [];
    this.organizationListData = this.organizationListData.concat(_or);

    this.depId = this.userData.secDepIds.split(",")[0] / 1;

    if (this.depId == "7" || this.backRole("SYSTEM_1")) {
      this.noSelectOrganization = false;
      this.depId = 0;
    }

    // 获取项目组
    this.getTeam();
  },
  methods: {
    showPayDetail(row) {
      this.nowProjectName = row.projectName;
      this.nowProjectId = row.projectId;
      this.payInfoStatus = true;
    },
    // 获取项目组
    getTeam() {
      ajax.post("/gc/project/team/list", "", (res) => {
        this.teamArr = [
          {
            id: 0,
            name: "全部",
          },
        ];
        this.teamArr = this.teamArr.concat(res.vo.array);
      });
    },
    // 当前页
    handleCurrentChange(val) {
      this.form.page = val - 1;
      this.getLists();
    },
    // 重置
    resetFilterData() {
      this.form.page = 0;
      this.form.pageSize = 22;
      this.projectType = -1;
      this.teamId = 0;
      this.filterKey = "";
      this.startTime = "";
      this.endTime = "";

      // 获取符合条件的列表
      this.getLists();
    },
    // 搜索筛选数据
    getFilterData() {
      this.form.page = 0;

      this.getLists();
    },
    // 分页筛选数据
    getPaginationData() {
      // 分页筛选
      this.paginationData = this.filterData;
    },
    // 获取列表
    getLists() {
      let _form = {
        depId: this.depId == 0 ? "" : this.depId,
        isWx: this.isWx,
        wxType: this.wxType,
        teamId: this.teamId == 0 ? "" : this.teamId,
        filterKey: this.filterKey,
        page: this.form.page,
        pageSize: this.form.pageSize,
      };
      if (this.startTime) {
        _form.startTime = this.startTime + " 00:00:00";
      }
      if (this.endTime) {
        _form.endTime = this.endTime + " 23:59:59";
      }

      this.loading = true;
      ajax.get("/pay/report", _form, (res) => {
        this.loading = false;
        this.filterData = this.listData = res.vo.list;
        this.form.pageTotal = res.vo.size;
        this.getPaginationData();
      });
    },
  },
  watch: {
    depId() {
      this.getLists();
    },

    projectType() {
      switch (this.projectType) {
        case -1:
          this.isWx = "";
          this.wxType = "";
          break;
        case 0:
          this.isWx = false;
          this.wxType = "";
          break;
        case 1:
          this.isWx = true;
          this.wxType = "A";
          break;
        case 2:
          this.isWx = true;
          this.wxType = "B";
          break;
        default:
          this.isWx = "";
          this.wxType = "";
          break;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/payOverviewList.vue